<script lang="ts">
    import { mdiChevronUp } from "@mdi/js";
    import {
        Card,
        CardTitle,
        ListGroup,
        Divider,
        List,
        ListItem,
        Icon,
        ProgressCircular,
    } from "svelte-materialify/src";
    import { Doc } from "sveltefire";

    let cloudActive = false;
    let devopsActive = false;
    let frameworkActive = false;
</script>

<Card outlined>
    <CardTitle class="card-title">My Technologies</CardTitle>
    <Divider />
    <List>
        <Doc
            path={"technologies/cloud"}
            traceId={"technologiesCloudRead"}
            let:data={cloudInfo}
        >
            <ListGroup bind:active={cloudActive}>
                <span slot="activator" class="block-wrap remove-break"
                    >Cloud Systems I Have Used</span
                >
                <span slot="append">
                    <Icon path={mdiChevronUp} rotate={cloudActive ? 0 : 180} />
                </span>
                {#each cloudInfo.systems.sort() as system, i}
                    <ListItem
                        class="cursor-default remove-break"
                        style="color: var(--theme-text-secondary)"
                        >{system}</ListItem
                    >
                    {#if i + 1 < cloudInfo.systems.length}
                        <Divider />
                    {/if}
                {/each}
            </ListGroup>
            <span slot="loading">
                <ProgressCircular indeterminate color="primary" /></span
            >
            <span slot="fallback">Error loading data</span>
        </Doc>
        <Doc
            path={"technologies/devops"}
            traceId={"technologiesDevopsRead"}
            let:data={devopsInfo}
        >
            <ListGroup bind:active={devopsActive}>
                <span slot="activator" class="block-wrap remove-break"
                    >DevOps Tools I Have Used</span
                >
                <span slot="append">
                    <Icon path={mdiChevronUp} rotate={devopsActive ? 0 : 180} />
                </span>
                {#each devopsInfo.systems.sort() as system, i}
                    <ListItem
                        class="cursor-default remove-break"
                        style="color: var(--theme-text-secondary)"
                        >{system}</ListItem
                    >
                    {#if i + 1 < devopsInfo.systems.length}
                        <Divider />
                    {/if}
                {/each}
            </ListGroup>
            <span slot="loading">
                <ProgressCircular indeterminate color="primary" /></span
            >
            <span slot="fallback">Error loading data</span>
        </Doc>
        <Doc
            path={"technologies/frameworks"}
            traceId={"technologiesFrameworkRead"}
            let:data={frameworkInfo}
        >
            <ListGroup bind:active={frameworkActive}>
                <span slot="activator" class="block-wrap remove-break"
                    >Frameworks and Libraries I Have Used</span
                >
                <span slot="append">
                    <Icon
                        path={mdiChevronUp}
                        rotate={frameworkActive ? 0 : 180}
                    />
                </span>
                {#each frameworkInfo.systems.sort() as system, i}
                    <ListItem
                        class="cursor-default remove-break"
                        style="color: var(--theme-text-secondary)"
                        >{system}</ListItem
                    >
                    {#if i + 1 < frameworkInfo.systems.length}
                        <Divider />
                    {/if}
                {/each}
            </ListGroup>
            <span slot="loading">
                <ProgressCircular indeterminate color="primary" /></span
            >
            <span slot="fallback">Error loading data</span>
        </Doc>
    </List>
</Card>
